import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { list } from "../features/paymentLog/paymentLogSlice";

const PaymentLog = () => {
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 1000,
    key: "",
    status: "",
  });

  useEffect(() => {
    dispatch(list(pagination));
  }, [dispatch, pagination]);

  const { logs, total, isLoading } = useSelector((state) => state.paymentLogs);

  const handleTableChange = (pagination) => {
    dispatch(list(pagination));
    setPagination({
      ...pagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  useEffect(() => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      total: total,
    }));
  }, [total]);

  const columns = [
    {
      title: "Date",
      render: (record) => {
        const date = new Date(record.createdAt);
        const formattedDate = date.toLocaleDateString("en-US", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
        return `${formattedDate}, ${formattedTime}`;
      },
      key: "createdAt",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Message",
      dataIndex: "message",
    },
    {
      title: "Data",
      key: "data",
      render: (record) => {
        return (
          <div
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word", // Wraps long words
            }}
          >
            {record.data}
          </div>
        );
      },
    },
  ];
  return (
    <div>
      <div className="row-space-between">
        <h3 className="mb-4 title">Payment Logs</h3>
      </div>
      <p> {isLoading} </p>
      <div>
        <Table
          columns={columns}
          dataSource={logs}
          rowKey={(record) => record._id}
          onChange={handleTableChange}
          pagination={pagination}
          loading={isLoading}
        />
      </div>
    </div>
  );
};

export default PaymentLog;
